export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-01.a72f10af.png";